import { Controller, useFormContext } from "react-hook-form";
import CurrencyInput from "../shared/CurrencyInput";

const CurrencyField = ({ name, label, disabled, size = "small", placeholder, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <CurrencyInput
          label={label}
          value={field.value}
          onChange={(val) => field.onChange(val)}
          onBlur={field.onBlur}
          disabled={disabled}
          size={size}
          placeholder={placeholder}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          fullWidth
          {...rest}
        />
      )}
    />
  );
};

export default CurrencyField;
